import { SideBar } from 'Components/SideBar';
import { Header } from 'Components/Header';
import { Main, SecondColumn } from '../styles';
import { Footer } from 'Components/Footer';
import { useSelector } from 'react-redux';
import { useMenuStatus } from 'store/menu';
import { useAuthTenant } from 'store/auth';
import { useQuery } from 'react-query';
import { getBrandingForDisplay } from 'services/company-service';
import { useEffect } from 'react';
import { getTenant } from 'utils/tenant_utils';
import { applyPrimaryColorVars, clearPrimaryColorVars } from 'utils/color_utils';

export const LayoutAuthenticated = ({children}) => {
    const openMenu = useSelector(useMenuStatus);
    const tenant = useSelector(useAuthTenant);

    const tenantSlug = tenant?.slug;

    const { data: brandingData } = useQuery(['company-branding', tenantSlug], getBrandingForDisplay, {
        staleTime: 5 * 60 * 1000,
        retry: false,
    });

    // Clear CSS vars immediately when tenant changes, before new data arrives
    // LIKELY REDUNDANT (flagged 2026-08-06, not removed): mutation-testing tenant-branding-css-
    // flash.spec.js (disable/confirm-fail/restore/confirm-pass, run live twice) showed this
    // effect's removal doesn't make that spec fail. The second effect below (dep=[brandingData])
    // already clears both vars itself whenever tenantSlug changes to a tenant with no fresh
    // cached query result — react-query resets `data` to undefined for the new key on the same
    // render, so `branding?.primaryColor` is falsy there too. Both effects run in the same
    // passive-effect flush either way. Caveat: this hasn't been tested for a switch BACK to a
    // tenant whose branding query is still within staleTime (cached, non-undefined data
    // available immediately) — that path might still rely on this effect. Worth evaluating for
    // removal, not done here.
    useEffect(() => {
        const root = document.documentElement;
        clearPrimaryColorVars(root);
        root.style.removeProperty('--color-secondary');
    }, [tenantSlug]);

    useEffect(() => {
        const root = document.documentElement;
        const favicon = document.querySelector('link[rel="icon"]');
        const defaultFavicon = '/favicon.ico';

        const branding = brandingData?.data?.branding;

        if (branding?.primaryColor) {
            applyPrimaryColorVars(root, branding.primaryColor);
        } else {
            clearPrimaryColorVars(root);
        }

        if (branding?.secondaryColor) {
            root.style.setProperty('--color-secondary', branding.secondaryColor);
        } else {
            root.style.removeProperty('--color-secondary');
        }

        if (favicon) {
            favicon.href = branding?.faviconUrl || defaultFavicon;
        }
    }, [brandingData]);

    const isAlternateTenant = tenant != null && tenantSlug !== getTenant();

    return (
        <Main>
            <SideBar/>
            <SecondColumn
                className={openMenu ? 'menu-open' : 'menu-close'}
                style={{ paddingTop: isAlternateTenant ? '112px' : '64px' }}
            >
                <Header openMenu={openMenu}/>
                <main style={{marginBottom: '40px', position: 'relative'}}>
                    {children}
                </main>
                <Footer/>
            </SecondColumn>
        </Main>
    )
}